import { Fragment } from 'react'
import { renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { styles } from './styles'

export type FooterProps = {
  allowReplies: boolean
  allowSharing: boolean
  cta?: string
  ctaUrl?: string
}

export const InstagramStoryFooter: React.FC<FooterProps> = ({
  allowReplies,
  allowSharing,
  cta,
  ctaUrl,
}) => {
  const isValidCta = cta && ctaUrl

  return (
    <Fragment>
      <div css={styles.ctaWrapper}>
        {isValidCta && !allowReplies && (
          <div css={styles.ctaAndIcon}>
            {renderIcon('instagram-mobile-swipe-up-outline', {
              ariaMode: 'hidden',
              height: 7,
              width: 18,
            })}
            <div css={styles.ctaStyles}>{cta}</div>
          </div>
        )}
      </div>
      <div
        className={kuiperClassNames('instagram-story-footer')}
        css={styles.getFooterStyles(!allowReplies)}
      >
        {allowReplies && !isValidCta && (
          <div css={styles.sendMessageStyles}>
            <span>Send Message</span>
          </div>
        )}
        {allowSharing && (
          <div css={styles.sharingStyles}>
            {renderIcon('instagram-mobile-send', {
              ariaMode: 'hidden',
              height: 22,
              width: 24,
            })}
          </div>
        )}
      </div>
    </Fragment>
  )
}
